<template>
  <div v-if="completed && completed != 0" >
    <div class="row">
      <div class="col-10 pl-4 pt-2 pr-1">
        <!-- <progress max="100" class="w-100" :class="item.uploadPercentage == 100 ? 'bg-success': ''" :value="item.uploadPercentage"></progress> -->
        <div class="progress" style="height: 0.5rem">
          <div class="progress-bar progress-bar-striped" :class="completed == 100 ? 'bg-success' : ''" role="progressbar" v-bind:style="{ width: completed + '%'}" :aria-valuenow="completed" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
      </div>
      <div class="col-2 p-0" style="font-size: 13px">
        {{completed + "%"}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    completed: Number
  },
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Partials/percentageLoader.vue